const token = {
   csrf: '',
};

export default {
   setCsrfToken: (csrfToken: string) => {
      token.csrf = csrfToken;
   },
   getCsrfToken: () => token.csrf,
   hasCsrfToken: () => Boolean(token.csrf),
};
